export const VERB_TABS = {
	CONJUGATION: 'conjugation',
	DEFINITION: 'definition',
	USAGE: 'usage',
	QUIZ: 'quiz'
};

export const MAIN_TABS = {
	HOME: 'verbs',
	STATS: 'stats',
	ABOUT: 'about',
	QUIZ: 'allquiz',
	MESSAGES: 'messages',
	HINTS: 'hints'
};
